export default __webpack_public_path__ + "static/media/cpLaundryPassPinkBm.cfeae988.jpg";